import React, { createContext, useCallback, useMemo, useState } from "react";

export const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        show: false,
        type: "info", // 'success', 'error', 'info'
        message: "",
        link: null,
    });

    const showNotification = useCallback((type, message, link = null) => {
        setNotification({
            show: true,
            type,
            message,
            link,
        });
    }, []);

    const hideNotification = useCallback(() => {
        setNotification((prev) => ({
            ...prev,
            show: false,
        }));
    }, []);

    const notify = useMemo(
        () => ({
            success: (message, link = null) =>
                showNotification("success", message, link),
            error: (message, link = null) =>
                showNotification("error", message, link),
            info: (message, link = null) =>
                showNotification("info", message, link),
        }),
        [showNotification],
    );

    const value = useMemo(
        () => ({
            notification,
            showNotification,
            hideNotification,
            notify,
        }),
        [hideNotification, notification, notify, showNotification],
    );

    return (
        <NotificationContext.Provider value={value}>
            {children}
        </NotificationContext.Provider>
    );
};
